import type { MailboxInfo } from "owa-client-types";
import { default as getAccountBySourceId } from "./getAccountBySourceId";

export default function getMailboxInfoBySourceId(sourceId: string): MailboxInfo | undefined {
    return getAccountBySourceId(sourceId)?.mailboxInfo;
}
